import React from 'react';
import PropTypes from 'prop-types';

const LoginTopBar = ({ handleLoginClick }) => {
    return (
        <div
            className="slim-header--signup row d-none d-md-flex"
            data-login-topbar>
            <div className="slim-header__content mx-auto container ">
                <div className="col-12">
                    <strong>
                        <p className="py-0 my-3">
                            Hej!{' '}
                            <a
                                href="/login"
                                rel="nofollow"
                                title="Logga in"
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="Login"
                                onClick={e => handleLoginClick(e, '/')}>
                                Logga in
                            </a>
                            {` eller `}
                            <a
                                href="/register"
                                title="Bli medlem"
                                data-ga-category="Header"
                                data-ga-action="Navigation"
                                data-ga-label="BliMedlem">
                                bli medlem
                            </a>
                        </p>
                    </strong>
                </div>
            </div>
        </div>
    );
};

LoginTopBar.propTypes = {
    handleLoginClick: PropTypes.func
};

export default LoginTopBar;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/login-top-bar.jsx